namespace GeniuzPOS.ReportMasterData {
    export interface Report_1311Row {
        Id?: string;
        DocDate?: string;
        ShopId?: string;
        ShopName?: string;
        CatCode?: string;
        CatName?: string;
        Qty?: number;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSalesExVat?: number;
        NetSales?: number;
        VatOfNetSales?: number;
        FullName?: string;
        FullName1?: string;
    }

    export namespace Report_1311Row {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'ReportMasterData.Report_1311';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            DocDate = "DocDate",
            ShopId = "ShopId",
            ShopName = "ShopName",
            CatCode = "CatCode",
            CatName = "CatName",
            Qty = "Qty",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSalesExVat = "NetSalesExVat",
            NetSales = "NetSales",
            VatOfNetSales = "VatOfNetSales",
            FullName = "FullName",
            FullName1 = "FullName1"
        }
    }
}
